import CloseIcon from "@mui/icons-material/Close";
import { AlertContainer, CloseBtn, Message, StatusColor } from "./alert.styles";

interface AlertProps {
  type?: "success" | "error" | "warning" | "info";
  message: string;
  onClose?: () => void;
}

const Alert = ({ type = "info", message, onClose }: AlertProps) => {
  return (
    <AlertContainer>
      <StatusColor className={`alert-${type}`} />
      <Message>{message}</Message>
      {onClose && (
        <CloseBtn onClick={onClose} aria-label="close">
          <CloseIcon />
        </CloseBtn>
      )}
    </AlertContainer>
  );
};

export default Alert;
